window.addEventListener("swiperLoaded", () => {
	// eslint-disable-next-line no-unused-vars
	const swiper = new Swiper(".vet-and-nutritionist", {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 20,
		autoHeight: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 32,
			},
		},
	});
});
